import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, formatApiError } from "@/lib/api";
import { PhotoPicker } from "@/components/wh/PhotoPicker";

export function LotDialog({ open, onOpenChange, lot, onSaved, wh = "mercatino" }) {
  const [f, setF] = useState({ name: "", description: "", photos: [] });
  useEffect(() => {
    if (open) setF({ name: lot?.name || "", description: lot?.description || "", photos: lot?.photo_path ? [lot.photo_path] : [] });
  }, [open, lot]);
  const save = async (e) => {
    e.preventDefault();
    const body = { wh: lot?.wh || wh, name: f.name, description: f.description, photo_path: f.photos[0] || null };
    try {
      const { data } = lot ? await api.put(`/wh/lots/${lot.id}`, body) : await api.post("/wh/lots", body);
      toast.success(lot ? "Lotto aggiornato" : "Lotto creato");
      onOpenChange(false);
      onSaved(lot ? lot.id : data.id);
    } catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[95dvh] overflow-y-auto" data-testid="lot-dialog">
        <DialogHeader><DialogTitle>{lot ? "Modifica lotto" : "Nuovo lotto"}</DialogTitle><DialogDescription>Un lotto è un cassetto virtuale che raccoglie articoli simili.</DialogDescription></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="space-y-1.5"><Label>Nome</Label><Input required maxLength={80} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Es. Lotto mobili" data-testid="lot-name-input" /></div>
          <div className="space-y-1.5"><Label>Descrizione (facoltativa)</Label><Textarea rows={3} maxLength={1000} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="lot-description-input" /></div>
          <div className="space-y-1.5"><Label>Foto identificativa</Label><PhotoPicker photos={f.photos} onChange={(photos) => setF({ ...f, photos })} max={1} testid="lot-photo" /></div>
          <button className="btn-primary h-11 px-5 w-full" data-testid="lot-save-button">Salva</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
